import { API_ROUTES } from '../constants';
import apiClient from './apiClient';

const API_URL=`${process.env.REACT_APP_API_URL}${API_ROUTES.CONVERSATION}`
const conversationService = {
  
    conversation: async (data) => {
        try {
          const response = await apiClient.post(API_URL, data);
          return response.data;
        } catch (error) {
          const errorMessage = error.response?.data?.message || 'Conversation failed';
          throw new Error(errorMessage);
        }
    },
}

export default conversationService